/*
  Passende Video-Fassung je Gerät (snippets/cx-video.liquid):
  - Safari/iOS nimmt die HLS-Quelle (adaptiv, startet sofort, wird scharf, sobald die Leitung es hergibt) – hier nichts zu tun.
  - Browser ohne HLS (Chrome/Android) bekommen auf Handys und kleinen Tablets die 720p-Datei statt 1080p: halb so groß,
    auf einem Handy-Display nicht zu unterscheiden, startet deutlich schneller. Liquid kennt nur die größte Fassung, darum
    wird die 720p-Adresse aus Shopifys Namensschema abgeleitet (…HD-1080p-7.2Mbps-123.mp4 → …HD-720p-4.5Mbps-123.mp4)
    und vor dem Umschalten mit einer winzigen Range-Anfrage geprüft. Desktop bleibt bei 1080p.
*/
(function () {
  'use strict';
  var probe = document.createElement('video');
  if (probe.canPlayType && probe.canPlayType('application/vnd.apple.mpegurl') !== '') return;
  if (Math.min(window.innerWidth, window.innerHeight) > 820) return;
  var MAP = { '7.2': '4.5', '2.5': '1.6', '4.5': '2.1' }; // 1080p-Bitrate → 720p-Bitrate (Shopify-Transcoding)
  function derive720(url) {
    var m = /HD-1080p-([\d.]+)Mbps/.exec(url);
    if (!m || !MAP[m[1]]) return null;
    return url.replace('HD-1080p-' + m[1] + 'Mbps', 'HD-720p-' + MAP[m[1]] + 'Mbps');
  }
  function swap(v, url) {
    var wasPlaying = !v.paused;
    v.src = url;
    v.load();
    if (wasPlaying) v.play().catch(function () {});
  }
  function pick(v) {
    if (v.getAttribute('data-cx-picked')) return;
    v.setAttribute('data-cx-picked', '1');
    var s = v.querySelector('source[data-h="1080"]');
    if (!s) return;
    var url = derive720(s.getAttribute('src'));
    if (!url) return;
    fetch(url, { method: 'GET', headers: { Range: 'bytes=0-0' }, mode: 'cors', credentials: 'omit' })
      .then(function (r) { if (r.ok || r.status === 206) swap(v, url); })
      .catch(function () {});
  }
  function run(root) { (root || document).querySelectorAll('video[data-cx-video]').forEach(pick); }
  run();
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('video[data-cx-video]')) pick(n); else run(n); } }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
